import { FuelIcon } from './FuelIcon';

/**
 * author: Haley Halcyon
 * id 8E016660-0C3A-46EA-B3A5-8DC490238EC7
 * name fuel
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fuel.svg
 * tags
 * - Automotive 
 */
export const PetrolIcon = FuelIcon;
export default PetrolIcon